import React, { Component } from "react"
import Components from "../index"
import Button from "../button-v2/button"
import * as Icon from "react-feather"
import hultShield from "../../assets/images/logos/hult-shield.svg"

class ModalFormV2 extends Component {
  state = {
    displayModal: false,
  }
  toggleModal = (event) => {
    const { displayModal } = this.state
    event.preventDefault()
    if (document.getElementsByClassName("header").length > 0) {
      document
        .getElementsByClassName("header")[0]
        .classList.toggle("g--send-back")
    }
    if (document.getElementsByClassName("sticky-inner-wrapper").length > 0) {
      document
        .getElementsByClassName("sticky-inner-wrapper")[0]
        .classList.toggle("g--send-back")
    }
    this.setState({
      displayModal: !displayModal,
    })
    document.body.classList.toggle("g--no-scroll-v2")
  }
  render() {
    const { displayModal } = this.state
    return (
      <>
        <div
          className={`modal-form-v2 ${
            displayModal ? " modal-form-v2--visible" : ""
          }`}
        >
          <div className="modal-form-v2__card">
            <header className="modal-form-v2__header">
              <div className="modal-form-v2__header-left">
                <div className="modal-form-v2__logo">
                  <img alt="Hult" src={hultShield} />
                </div>
                {this.props.modal_title && (
                  <p className="modal-form-v2__title">
                    {this.props.modal_title}
                  </p>
                )}
              </div>
              <div className="modal-form-v2__close" onClick={this.toggleModal}>
                {Icon["X"] &&
                  React.createElement(Icon["X"], {
                    className: "icon icon--sm",
                  })}
              </div>
            </header>
            <div className={`modal-form-v2__form`}>
              {this.props.modal_form &&
                this.props.modal_form.map((c) =>
                  React.createElement(Components(c.component), {
                    key: c._uid,
                    blok: c,
                    isDark: false,
                  })
                )}
            </div>
          </div>
          <div
            className="modal-form-v2__background"
            onClick={this.toggleModal}
          ></div>
        </div>
        <Button
          onClick={this.toggleModal}
          className={this.props.className}
          label={this.props.label}
          accessibilityLabel={this.props.accessibilityLabel}
          icon={this.props.icon}
          variant={this.props.variant}
          spacing={this.props.spacing}
        />
      </>
    )
  }
}

export default ModalFormV2
